import api from '@http/api';

export interface IRequestCreateProgramaTV{
  descricao: string;
  id_programa: string,
  id_perfil: number,
  id_tipo_solicitacao: number,
  id_tipo_intencao_tv: number,
}

export interface IGetAllProgramaTv{
  id: number;
  nome: string;
}

class Services {

  public async CreateIntencao(data: IRequestCreateProgramaTV) {
    return await api
      .post('/api/SolicitacaoPrograma/CreateSolicitacaoPrograma', data)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }



  public async GetAllProgramaTv()
  {
    return await api
      .get<IGetAllProgramaTv[]>(`/api/Programa/GetAll`)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

}

export default Services;
